import ApiAuthorzationRoutes from 'components/api-authorization/ApiAuthorizationRoutes'
import { MainLayout } from 'app/layouts/MainLayout'
import type { RouteObject } from 'react-router-dom'

import {
    AboutPage,
    HomePage,
    HostServiceDetailPage,
    MonitorListPage,
    MonitorCreatePage,
    MonitorEditPage,
    MarketSpyResultDetailPage,
    MonitorsRunResultListPage,
    RecommendationsSettingsPage,
    NotificationsSettingsPage,
    NotificationListPage,
    InstallInstructionPage,
    PropertySpyListPage,
    PropertySpyItemDetailPage,
    PropertySpyCreatePage,
    MarketPage,
    PropertyPage,
    PropertySpyResultListPage,
    CompetitorsPage,
    SettingsPage,
} from 'pages';
import { createBrowserRouter } from 'react-router-dom';

const routes: any[] = [
    {
        element: <MainLayout />,
        handle: { mode: `property` },
        children: [
            {
                path: "/",
                element: <CompetitorsPage />
            },
        ],
    },
    {
        element: <MainLayout />,
        handle: {
            mode: `property`
        },
        children: [
            {
                path: "property",
                element: <PropertyPage />
            },
            {
                path: "competitors",
                element: <CompetitorsPage />
            }
        ],
    },
    {
        element: <MainLayout />,
        children: [
            {
                path: "notifications",
                element: <NotificationListPage />,

            },
        ],
    },
    {
        element: <MainLayout />,
        children: [
            {
                path: "about",
                element: <AboutPage />,
            },          
            {
                path: "hostservice/:hostServiceId",
                element: <HostServiceDetailPage />,
            },
            {
                path: "recommendations",
                element: <RecommendationsSettingsPage />,
            },

            {
                path: "notifications/settings",
                element: <NotificationsSettingsPage />,
            },
            {
                path: "spy/select/results",
                element: <MarketSpyResultDetailPage />,
            },
            {
                path: "spy/:marketSpyId/results",
                element: <MarketSpyResultDetailPage />,
            },
            {
                path: "spy/:marketSpyId?/monitorrun",
                element: <MarketSpyResultDetailPage />,
            },
            {
                path: "spy",
                element: <MonitorListPage />,
            },
            {
                path: "spy/:id",
                element: <MonitorEditPage />,
            },
            {
                path: "spy/create",
                element: <MonitorCreatePage />,
            },
            {
                path: "spy/edit",
                element: <MonitorEditPage />,
            },

            {
                path: "results",
                element: <MonitorsRunResultListPage />,
            },
            {
                path: "results/:monitorId",
                element: <MarketSpyResultDetailPage />,
            },
            {
                path: "/install/instruction",
                element: <InstallInstructionPage />,
            },
            {
                path: "/install/instruction",
                element: <InstallInstructionPage />,
            },
            {
                path: "propertyspy",
                element: <PropertySpyListPage/>
            },
            {
                path: "propertyspy/:id",
                element: <PropertySpyItemDetailPage />
            },
            {
                path: "propertyspy/create",
                element: <PropertySpyCreatePage />
            },
            {
                path: "propertyspy/select/results",
                element: <PropertySpyResultListPage />,
            },
            {
                path: "propertyspy/:propertySpyId/results",
                element: <PropertySpyResultListPage />,
            },
            {
                path: "market",
                element: <MarketPage />,
                applicationMode: 'market',
            },
            {
                path: "settings",
                element: <SettingsPage />,
            },                
        ],
    },
    ...ApiAuthorzationRoutes,
];

export const router = createBrowserRouter(routes)

